<!--
 * Path: src/core/components/dialogs/Notification.vue
 * Task: Global notification snackbar component pulling its state directly from the extended auth store, aligned with responsive theme states.
-->
<template>
  <v-snackbar
    v-model="config.show"
    :color="config.type"
    :timeout="config.timeout"
    location="bottom right"
    elevation="4"
    class="mb-4 mr-4"
  >
    <div class="d-flex align-center">
      <v-icon class="me-3" color="white" size="24">{{ icon }}</v-icon>
      <span class="text-white font-weight-medium text-body-2">{{ config.message }}</span>
    </div>
    <template v-slot:actions>
      <v-btn icon="mdi-close" color="white" variant="text" size="small" @click="config.show = false"></v-btn>
    </template>
  </v-snackbar>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, onUnmounted } from 'vue';

// CRITICAL FIX: The ref MUST be initialized with an object containing 'show'
// so the template doesn't crash on initial render.
const config = ref({
  show: false,
  message: '',
  type: 'info',
  timeout: 4000
});

const icon = computed(() => {
  switch (config.value.type) {
    case 'success': return 'mdi-check-circle-outline';
    case 'error': return 'mdi-alert-octagon-outline';
    case 'warning': return 'mdi-alert-outline';
    default: return 'mdi-information-outline';
  }
});

const handleNotification = (event: Event) => {
  const customEvent = event as CustomEvent;
  if (customEvent.detail) {
    config.value.message = customEvent.detail.message || 'System Notification';
    config.value.type = customEvent.detail.type || 'info';
    config.value.show = true;
  }
};

onMounted(() => {
  window.addEventListener('show-notification', handleNotification);
});

onUnmounted(() => {
  window.removeEventListener('show-notification', handleNotification);
});
</script>
